import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { auth, db, initializeSuperUser } from '../services/firebase';
import { useState, useEffect } from 'react';
import { collection, query, where, getDocs, doc, setDoc } from 'firebase/firestore';

function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSuperUser, setIsSuperUser] = useState(false);

  useEffect(() => {
    const checkSuperUser = async () => {
      console.log('Checking super user status...');
      console.log('Current user:', auth.currentUser?.email);
      
      if (auth.currentUser?.email === 'jared@heytheremedia.com') {
        try {
          console.log('Attempting to initialize super user...');
          await initializeSuperUser();
          
          console.log('Checking super_users collection...');
          const superUsersRef = collection(db, 'super_users');
          const q = query(superUsersRef, where('email', '==', auth.currentUser.email));
          const querySnapshot = await getDocs(q);
          
          console.log('Query results:', querySnapshot.size, 'documents found');
          const isSuperUserFound = !querySnapshot.empty;
          console.log('Setting isSuperUser to:', isSuperUserFound);
          setIsSuperUser(isSuperUserFound);
          
          // Log the actual documents for debugging
          querySnapshot.forEach(doc => {
            console.log('Found super user document:', doc.id, doc.data());
          });
        } catch (error) {
          console.error('Error in super user check:', error);
          // Try to create collection again if it doesn't exist
          try {
            console.log('Retrying super user initialization...');
            const superUserRef = doc(db, 'super_users', 'jared');
            await setDoc(superUserRef, {
              email: 'jared@heytheremedia.com',
              super_user: true,
              created_at: new Date().toISOString()
            });
            setIsSuperUser(true);
            console.log('Super user created on retry');
          } catch (retryError) {
            console.error('Retry failed:', retryError);
          }
        }
      } else {
        console.log('Not jared@heytheremedia.com, setting isSuperUser to false');
        setIsSuperUser(false);
      }
    };

    if (auth.currentUser) {
      checkSuperUser();
    } else {
      setIsSuperUser(false);
    }
  }, [auth.currentUser]);

  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container>
          {location.pathname !== '/login' && (
            <Link to="/" style={{ marginRight: '20px' }}>
              <img 
                src="/images/Grizzly_FullCabin.jpg" 
                alt="White Grizzly Tippin" 
                style={{
                  width: '100px',
                  borderRadius: '8px',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  transition: 'transform 0.2s ease-in-out'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              />
            </Link>
          )}
        <Navbar.Brand as={Link} to="/">Tippin' Grizzly</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/">Home</Nav.Link>
            <Nav.Link as={Link} to="/about">About</Nav.Link>
            {auth.currentUser ? (
              <>
                <Nav.Link as={Link} to="/members">Members</Nav.Link>
                <Nav.Link as={Link} to="/itinerary">
                  <i className="bi bi-calendar-event me-1"></i>
                  Itinerary
                </Nav.Link>
              </>
            ) : (
              <Nav.Link as={Link} to="/login">Login</Nav.Link>
            )}
          </Nav>
          {auth.currentUser && (
            <Nav>
              <Nav.Link 
                as={Link} 
                to="/dashboard" 
                style={{ color: 'rgba(255,255,255,0.7)', textAlign: 'right' }}
              >
                <div>
                  <i className="bi bi-person-circle me-1"></i>
                  {auth.currentUser.email}
                </div>
                {isSuperUser && (
                  <div style={{ 
                    fontSize: '0.8em', 
                    fontStyle: 'italic',
                    color: 'rgba(255,255,255,0.5)'
                  }}>
                    Super User
                  </div>
                )}
              </Nav.Link>
            </Nav>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation; 